<div nxLayout="grid maxwidth" class="cards">
    <div nxRow>
        <ng-template ngFor let-group="$implicit" [ngForOf]="groupsWPolicies" let-i="index"
            *ngIf="groupsWPolicies.length>0">
            <div [nxCol]="nxCol[group.cols]" class="cardColumn">
                <cpc-card-group>

                    <cpc-card-header variant="{{ (group.name == 'car-insurance-ek')? 'ev' :'Active'}}"
                        [title]="'active-insurance-group.' + group.name | translate"
                        [badge]="'group-state.active' | translate: { count: group.count > 1 ? group.count : '' }"
                        [icon]="group.icon"></cpc-card-header>

                    <ng-template ngFor let-policy="$implicit" [ngForOf]="group.policies">
                        <cpc-card type="entries">
                            <cpc-card-entry type="entry-1">
                                <span title translate>home.product-name</span>
                                <b>{{ this.b2b.getProductName(policy) }}</b>
                            </cpc-card-entry>
                            <cpc-card-entry type="entry-2">
                                <span title translate>policy.policy-number</span>
                                <b>{{ policy.policyNumber }}</b>
                            </cpc-card-entry>
                            <cpc-card-entry footer>
                                <cpc-button size="small" title (click)="openPolicyDetail(policy)"><span
                                        translate>home.details</span></cpc-button>
                            </cpc-card-entry>
                        </cpc-card>
                    </ng-template>

                </cpc-card-group>
            </div>
        </ng-template>

        <div nxCol="12" class="cardColumn" *ngIf="groupsWPolicies.length == 0">
            <span translate>home.no-active-text</span>
        </div>

    </div>
</div>